import * as React from 'react';

import FileDefault32 from './FileDefault32';

export const fileDefault32 = () => <FileDefault32 />;

export default {
    title: 'Icon|Content|FileDefault32',
    component: FileDefault32,
    parameters: {
        notes: "`import FileDefault32 from 'box-ui-elements/es/icon/content/FileDefault32';`",
    },
};
